import { Outlet } from "react-router-dom"

import { Card } from "../ui/card"
import authCover from "../../assets/images/auth-cover.jpg"
export default function AuthLayout () {
  return (
    <div className="h-screen flex flex-col items-center justify-center">
      <Card className="w-9/12 h-[20em] grid md:grid-cols-[2fr_3fr] min-h-[30em]">
        <div className="size-full bg-contain bg-no-repeat rounded-lg px-4 bg-center" style={{backgroundImage: `url("${authCover}")`}}>
        </div>
        <Outlet />
      </Card>

    </div>
  )
}
